import PartnerLayout from "../../components/layout/partnerLayout";
import MobilePartnerShell from "../shell/MobilePartnerShell";
import { useIsMobile } from "../hooks/useIsMobile";

function AdaptivePartnerLayout() {
  const isMobile = useIsMobile();
  return isMobile ? <MobilePartnerShell /> : <PartnerLayout />;
}

export default AdaptivePartnerLayout;
